import React, { useState } from "react"
import { Editor } from "@tiptap/core"
import { CheckIcon, PlusIcon } from "@heroicons/react/24/outline"
import classNames from "classnames"
import { v4 as uuidv4 } from "uuid"

import { store as imageStore } from "./image"

const classNamesForButton = (isActive: boolean | undefined, extras?: string) =>
  classNames(
    "px-2 py-1 rounded bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100 shrink-0 no-wrap",
    extras,
    {
      "bg-gray-200 dark:bg-gray-600 font-bold": isActive,
    }
  )

export default function NewBlockMenu({ editor }: { editor: Editor }) {
  const header1 = () => editor.chain().focus().toggleHeading({ level: 1 }).run()
  const header2 = () => editor.chain().focus().toggleHeading({ level: 2 }).run()
  const header3 = () => editor.chain().focus().toggleHeading({ level: 3 }).run()
  const bulletList = () => editor.chain().focus().toggleBulletList().run()
  const orderedList = () => editor.chain().focus().toggleOrderedList().run()
  const blockquote = () => editor.chain().focus().toggleBlockquote().run()
  const code = () => editor.chain().focus().toggleCodeBlock().run()
  const horizontalRule = () => editor.chain().focus().setHorizontalRule().run()
  const taskList = () => editor.chain().focus().toggleTaskList().run()
  const equation = () => editor.chain().focus().setMathBlock().run()
  const image = () => {
    const uuid = uuidv4()
    imageStore.setImageState(uuid, { type: "empty" })
    editor.chain().focus().setImage({ uuid: uuid }).run()
  }

  return (
    <div className="new-block-menu flex items-center opacity-80">
      <PlusIcon className="w-4 h-4 dark:text-gray-400" />
      <div className="flex gap-1 dark:text-gray-300 select-none cursor-pointer text-xs font-medium">
        <div
          onClick={header1}
          className={classNamesForButton(
            editor.isActive("heading", {
              level: 1,
            })
          )}
        >
          H1
        </div>
        <div
          onClick={header2}
          className={classNamesForButton(
            editor.isActive("heading", {
              level: 2,
            })
          )}
        >
          H2
        </div>
        <div
          onClick={header3}
          className={classNamesForButton(
            editor.isActive("heading", {
              level: 3,
            })
          )}
        >
          H3
        </div>
        <div onClick={bulletList} className={classNamesForButton(false)}>
          * --
        </div>
        <div onClick={orderedList} className={classNamesForButton(false)}>
          1. --
        </div>
        <div onClick={blockquote} className={classNamesForButton(false)}>
          ".."
        </div>
        <div onClick={code} className={classNamesForButton(false, "font-mono")}>
          CODE
        </div>
        <div onClick={horizontalRule} className={classNamesForButton(false)}>
          ---
        </div>
        <div onClick={taskList} className={classNamesForButton(false, "")}>
          <CheckIcon className="w-4 h-4 dark:text-gray-400" />
        </div>
        <div onClick={equation} className={classNamesForButton(false, "")}>
          √x
        </div>
        <div onClick={image} className={classNamesForButton(false, "p-1")}>
          <div className="rounded border border-gray-500">IMG</div>
        </div>
      </div>
    </div>
  )
}
